import {
  IonButton,
  IonRow,
  IonCol,
} from "@ionic/react";

function BannerTourendata(props) {
  return (
    <>
        <IonRow
            className="advertorial__container"
        >
            <IonCol
            className="touren__background__image "
            size="12"
            size-md="6"
            style={{
                background: `url('${props.tourenImageUrl}') no-repeat center`,
            }}
            ></IonCol>
            <IonCol
            size="12"
            size-md="6"
            className="ion-padding-start ion-padding-end "
            style={{ paddingTop: "0" }}
            >
            <div style={{ marginTop: "0px", textAlign: "right", color: "#999", fontSize: "12px" }}>Anzeige</div>
            <h6>Camping-Tipp</h6>
            <h3>{props.tourenName}</h3>
            <p>{props.tourenExcerpt}</p>
            <br />
            <IonButton
                color="secondary"
                shape="round"
                href={props.tourenLink}
            >
                Mehr erfahren
            </IonButton>{" "}
            </IonCol>
        </IonRow>
    </>
  );
}

export default BannerTourendata;